import axios from "axios";

const api = axios.create({
  // baseURL: "http://44.201.206.142",
  baseURL: "https://api.beachtennis.life/",
});

export default api;
